export default {
  'it-IT': {
    recentlyViewedProducts: 'Visti di recente',
  },
  'fr-FR': {
    recentlyViewedProducts: 'Récemment consultés',
  },
  'es-ES': {
    recentlyViewedProducts: 'Visto recientemente',
  },
  'en-GB': {
    recentlyViewedProducts: 'Recently viewed',
  },
  'en-US': {
    recentlyViewedProducts: 'Recently viewed',
  },
  'de-DE': {
    recentlyViewedProducts: 'Kürzlich angeschaut',
  },
  'en-AU': {
    recentlyViewedProducts: 'Recently viewed',
  },
  'ko-KR': {
    recentlyViewedProducts: 'Recently viewed',
  },
};
